import Swal from "sweetalert2";
import {
    login,
    signUp,
    runLogoutTimer,
    saveTokenInLocalStorage,
} from "../../services/AuthService";
import { getUserProfile } from "../../firebase/userService";
import config from '../../config';

/* ================= ACTION TYPES ================= */

export const SIGNUP_CONFIRMED_ACTION = "[signup] confirmed";
export const SIGNUP_FAILED_ACTION = "[signup] failed";
export const LOGIN_CONFIRMED_ACTION = "[login] confirmed";
export const LOGIN_FAILED_ACTION = "[login] failed";
export const LOADING_TOGGLE_ACTION = "[loading] toggle";
export const LOGOUT_ACTION = "[logout]";
export const NAVTOGGLE = "NAVTOGGLE";

/* ================= SIGNUP ================= */

export function signupAction(email, password) {
    return async (dispatch) => {
        try {
            dispatch(loadingToggleAction(true));

            const response = await signUp(email, password);

            saveTokenInLocalStorage(response.data);

            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000
            );

            dispatch(confirmedSignupAction(response.data));
        } catch (error) {
            dispatch(signupFailedAction("Signup failed"));
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

/* ================= LOGIN (WITH SPINNER) ================= */


export function loginAction(email, password) {
    return async (dispatch) => {
        try {
            dispatch(loadingToggleAction(true));

            // 🔐 Firebase login
            const userCredential = await login(email, password);
            const user = userCredential.user;
            const uid = user.uid;
            const idToken = await user.getIdToken();

            // ⏳ Expire in 1 hour
            const expireDate = new Date(
                Date.now() + 60 * 60 * 1000
            ).toISOString();

            // 🔥 Fetch profile
            const res = await fetch(
                `${config.apiBaseUrl}/get-user-by-uid.php`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ uid }),
                }
            );

            const profile = await res.json();

            if (!res.ok || profile.success === false) {
                Swal.fire(
                    "Access Denied",
                    profile.message || "Profile not found",
                    "error"
                );
                dispatch(loginFailedAction("Profile not found"));
                return;
            }

            // ✅ Update last login (silent, never block login)
            try {
                await fetch(
                    `${config.apiBaseUrl}/users/update-last-login.php`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ uid }),
                    }
                );
            } catch (e) {
                console.warn("Last login update failed:", e);
            }

            const tokenDetails = {
                token: idToken,
                uid,
                email: user.email,
                role: profile.role,
                fullname: profile.fullname || "",
                expireDate,
            };

            saveTokenInLocalStorage(tokenDetails);
            runLogoutTimer(dispatch, 60 * 60 * 1000);

            dispatch(loginConfirmedAction(tokenDetails));

        } catch (error) {
            console.error("Login error:", error);

            Swal.fire({
                icon: "error",
                title: "Login Failed",
                text: "Invalid email or password",
            });

            dispatch(loginFailedAction("Login failed"));
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}


/* ================= LOGOUT ================= */

export function Logout() {
    localStorage.removeItem("userDetails");
    return { type: LOGOUT_ACTION };
}

/* ================= ACTION CREATORS ================= */

export function loginConfirmedAction(payload) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload,
    };
}

export function loginFailedAction(message) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: message,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export const navtoggle = () => ({ type: NAVTOGGLE });
